import { Navigate, Outlet } from "react-router-dom";
import { getFromLocalStorage } from "../utils/storageUtil";

const AuthProtected = () => {
    const admin = getFromLocalStorage('admin')
    return (
        admin ? <Navigate to='/admin/dashboard' /> : <Outlet />
    )
}

export default AuthProtected;